import { render, staticRenderFns } from "./BoxedLayout.vue?vue&type=template&id=150d2db4"
import script from "./BoxedLayout.vue?vue&type=script&lang=js"
export * from "./BoxedLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports